import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';
import PropTypes from 'prop-types';
import React from 'react';

const {
  REACT_APP_HONEYBADGER_API_KEY: HONEYBADGER_API_KEY,
  REACT_APP_ENV: ENVIRONMENT,
} = process.env;

const config = {
  apiKey: HONEYBADGER_API_KEY,
  environment: ENVIRONMENT,
  enableUncaught: false,
  enableUnhandledRejection: false,
};

export const honeybadger = Honeybadger.configure(config);
const GlobalErrorBoundary = ({ children }) => {
  return <HoneybadgerErrorBoundary honeybadger={honeybadger}>{children}</HoneybadgerErrorBoundary>;
};

GlobalErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GlobalErrorBoundary;
